import { Component } from '@angular/core'

@Component({
  selector: 'se-po-guardian-invite-info-docs',
  templateUrl: './guardian-invite-info-docs.component.html',
  styleUrls: ['./guardian-invite-info-docs.component.scss'],
  standalone: false,
})
export class GuardianInviteInfoDocsComponent {
  public models: string[]
  public headers: any = {
    GuardianInviteInfoComponent: [
      'Property',
      'Type',
      'Description',
    ],
    GuardianInviteInterface: [
      'Property',
      'Type',
      'Description',
    ]
  }
  public rows: any = {
    GuardianInviteInfoComponent: [
      {
        Property: '@Input() guardianToInvite',
        Type: 'GuardianInvite | PersonaGuardianInvite',
        Description: 'Guardian invite to display',
      }
    ],
    GuardianInviteInterface: [
      {
        Property: 'email',
        Type: 'string',
        Description: 'Email address for guardian'
      },
      {
        Property: 'access',
        Type: 'string',
        Description: 'Access level for guardian (viewer, manager)'
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
